window.actionLocator = {};

export const UNIT_RESOURCE = "UNIT_RESOURCE";
export const CATALOG_RESOURCE = "CATALOG_RESOURCE";
export const LINE_ITEM_RESOURCE = "LINE_ITEM_RESOURCE";
export const SUB_LINE_ITEM_RESOURCE = "SUB_LINE_ITEM_RESOURCE";
export const PRODUCT_LINE_RESOURCE = "PRODUCT_LINE_RESOURCE";

export const setResource = (key, resource) => {
  window.actionLocator[key] = resource;
};

export const getResource = key => {
  return window.actionLocator[key];
};
